import Wrapper from "@/layout/wrapper/Wrapper";
import styled from "@emotion/styled";
import { Box, Container } from "@mui/system";
import React from "react";
import Grid from "@mui/material/Grid";
import assest from "@/json/assest";
import Image from "next/image";
import Typography from "@mui/material/Typography";
import { Tab, Tabs, Button, List, ListItem } from "@mui/material";
import Link from "next/link";
import WhatPeopleSay from "@/components/WhatPeopleSay/WhatPeopleSay";
import CommonHeaderInner from "@/components/CommonHeaderInner/CommonHeaderInner";
import Seo from "@/components/Seo/Seo";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box> {children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SpecialSec = styled(Box)`
  .carrerBox {
    background: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    position: relative;
    padding: 25px 30px;
    @media (max-width:1199px){
      padding: 25px 14px;
    }
    @media (max-width:899px){
      margin-bottom: 30px;
    }
    @media (max-width:599px){
      margin-bottom:0px;
    }
    &::after {
      background: #73c2fb;
      border-radius: 0 0 10px 10px;
      position: absolute;
      z-index: -9;
      bottom: -6px;
      left: 0;
      width: 100%;
      height: 15px;
      content: "";
    }
    h3 {
      font-weight: 500;
      font-size: 22px;
      line-height: 1.5;
      color: #000000;
      margin: 0 0 29px;
      @media (max-width:599px){
        margin-bottom: 12px;
      }
    }
    ul {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      @media (max-width:599px){
        margin-bottom: 12px;
      }
      li {
        display: flex;
        align-items: center;
        margin: 0 20px 0 0;
        span {
          font-weight: 400;
          font-size: 14px;
          text-transform: capitalize;
          color: rgba(0, 0, 0, 0.5);
        }
        img {
          margin: 0 5px 0 0;
        }
      }
    }
  }
  .special-sec {
    .career-rgt {
      background: #ffffff;
      box-shadow: 0px 15px 48px rgba(48, 15, 44, 0.12);
      border-radius: 10px;
      padding: 40px 22px;
      @media (max-width:599px){
        padding: 20px 10px;
      }
      .MuiBox-root {
        border: 0;
        .MuiButtonBase-root {
          font-family: "Ubuntu";
          font-weight: 500;
          font-size: 13px;
          line-height: 1.1;
          letter-spacing: 0.02em;
          color: #1e294c;
          max-width: 360px;
          min-width: 100px;
          min-height: 30px;
          padding: 4px 16px;
          margin-right: 12px;
          @media (max-width:599px){
            margin: 5px 2px;
          }
          &.Mui-selected {
            color: #ffffff;
            background: #1e294c;
            border-radius: 26px;
          }
        }
      }
      .career-tab {
        min-height: auto;
        &.MuiTabs-indicator {
          background-color: "orange" !important;
        }
        .MuiTabs-flexContainer{
          @media (max-width:599px){
            justify-content: center;
            flex-wrap: wrap;
            padding: 5px 0;
          }
        }
      }
      .tab-outr {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media (max-width:599px){
          display: block;
        }
        .followbtn {
          margin-right: 0;
          margin-left: 80px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #1e294c;
          border-radius: 39px;
          padding: 8px 16px;

          font-family: "Poppins";
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.02em;
          color: #5f6374;
          @media (max-width:599px){
            margin: 0 auto;
            display: flex;
          }
          img {
            margin-right: 10px;
          }
        }
      }
    }
  }
  .tab-panel {
    
    .tab-panel-top {
      padding-bottom: 34px;
      /* max-width: 540px; */
      padding-left: 22px;
      border-bottom: 1px solid #dbdbdb !important;
      @media (max-width:599px){
        padding-bottom: 20px;
        padding-left: 0;
      }
      h3 {
        margin-bottom: 12px;
        font-weight: 500;
        font-size: 18px;
        color: #1e294c;
        span {
          color: #73c2fb;
        }
      }
    }
    .tab-panel-usr {
      display: flex;
      align-items: center;
      figure {
        width: 27px;
        height: 27px;
        border-radius: 100%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .tab-panel-hdr-rgt {
        padding-left: 8px;
        p {
          font-weight: 400;
          font-size: 10px;
          color: #1e294c;
          line-height: 1.2;
        }
        h4 {
          font-weight: 600;
          font-size: 12px;
          line-height: 1.2;
          color: #73c2fb;
        }
      }
    }
  }
  .tab-dtls {
    .tab-dtls-hdr {
      span {
        display: flex;
        align-items: center;
        h5 {
          font-weight: 400;
          /* font-size: 10px; */
          font-size: 12px;
          color: #9ca3af;
          margin-left: 10px;
          margin-right: 10px;
        }
    
      h6 {
        font-weight: 600;
        font-size: 15px;

        color: #1e294c;
        display: flex;
        align-items: center;
        img {
          margin-left: 10px;
        }
      }  }
    }
  }
  .tab-panel-mdle {
    /* max-width: 540px; */
    padding: 30px 0;
    padding-left: 22px;
    border-bottom: 1px solid #dbdbdb !important;
    border-bottom: 1px solid #dbdbdb;
    @media (max-width:599px){
      padding: 20px 0;
        }
    ul.MuiList-root {
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      margin: -12px -10px;
      li {
        padding: 12px 10px;
        width: 33.33%;
        @media (max-width: 1199px){
          width: 50%;
        }
        @media (max-width:480px){
          width: 100%;
        }
      }
    }
  }
  .tab-panel-btm {
    padding-left: 22px;
    padding-top: 30px;
    @media (max-width:599px){
        padding-top: 20px;
        padding-left: 0;
      }
    h3 {
        margin-bottom: 12px;
        font-weight: 500;
        font-size: 18px;
        color: #1e294c;
      }

  }
`;

export default function index() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Wrapper>
      <Seo title="Career Details" canonical={""} description={""} url={""} image={""} />
      <CommonHeaderInner name="Careers" pageName="Careers" />
      <SpecialSec>
        <Box className="special-sec cmn_gap">
          <Container fixed>
            <Box className="sepcial-outr">
              <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                  <Box className="carrerBox">
                    <Typography variant="h3">Direct Support Professional (DSP)</Typography>
                    <ul>
                      <li>
                        <Image
                          src={assest.priceIcon}
                          width={12}
                          height={12}
                          alt="img"
                        />
                        <span>Variable</span>
                      </li>
                      <li>
                        <Image
                          src={assest.locationIcon}
                          width={12}
                          height={12}
                          alt="img"
                        />
                        <span>Springfield, Va</span>
                      </li>
                    </ul>
                    <Typography variant="body1">
                      Responsible for helping people with developmental disabilities lead richer lives
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Box className="career-rgt">
                    <Box className="tab-panel">
                      <Box className="tab-panel-top">
                        <Typography variant="h3">
                          Join our amazing and{" "}
                          <span> talented team</span>
                        </Typography>

                        {/* <Box className="tab-panel-usr">
                            <figure>
                              <Image
                                src={assest.tabUser}
                                alt="tabUser"
                                width="27"
                                height="27"
                              />
                            </figure>
                            <Box className="tab-panel-hdr-rgt">
                              <Typography variant="body2">Posted By</Typography>
                              <Typography variant="h4">John Doe</Typography>
                            </Box>
                          </Box> */}
                      </Box>
                      <Box className="tab-panel-mdle">
                        <List>
                          {/* <ListItem>
                              <Box className="tab-dtls">
                                <Box className="tab-dtls-hdr">
                                <span>
                                    <Image
                                      src={assest.tabIcon1}
                                      alt="icon1"
                                      width="10"
                                      height="12"
                                    />
                                    <Typography variant="h5">
                                      {" "}
                                      Offers
                                    </Typography>
                                  </span> 
                                   <Typography variant="h6">
                                    192 Offers
                                  </Typography> 
                                </Box>
                              </Box>
                            </ListItem> */}
                          <ListItem>
                            <Box className="tab-dtls">
                              <Box className="tab-dtls-hdr">
                                <span>
                                  <Image
                                    src={assest.tabIcon2}
                                    alt="icon2"
                                    width="10"
                                    height="12"
                                  />
                                  <Typography variant="h5">
                                    {" "}
                                    Employment
                                  </Typography>
                                  <Typography variant="h6">
                                    Full Time
                                  </Typography>
                                </span>

                              </Box>
                            </Box>
                          </ListItem>
                          <ListItem>
                            <Box className="tab-dtls">
                              <Box className="tab-dtls-hdr">
                                <span>
                                  <Image
                                    src={assest.locationIcon}
                                    alt="icon1"
                                    width="10"
                                    height="12"
                                  />
                                  <Typography variant="h5">
                                    {" "}
                                    Location
                                  </Typography>

                                  <Typography variant="h6">
                                    In-Person{" "}
                                    <Image
                                      width="10"
                                      height="12"
                                      alt="icon9"
                                      src={assest.tabIcon9}
                                    />{" "}
                                  </Typography> </span>
                              </Box>
                            </Box>
                          </ListItem>
                          <ListItem>
                            <Box className="tab-dtls">
                              <Box className="tab-dtls-hdr">
                                <span>
                                  <Image
                                    src={assest.userIcon}
                                    alt="icon1"
                                    width="12"
                                    height="12"
                                  />
                                  <Typography variant="h5">
                                    {" "}
                                    Opening
                                  </Typography>
                                  <Typography variant="h6">
                                    1{" "}
                                  </Typography> </span>
                              </Box>
                            </Box>
                          </ListItem>
                          {/* <ListItem>
                              <Box className="tab-dtls">
                                <Box className="tab-dtls-hdr">
                                <span>
                                    <Image
                                      src={assest.tabIcon6}
                                      alt="icon6"
                                      width="10"
                                      height="12"
                                    />
                                    <Typography variant="h5">
                                      {" "}
                                      Attachment
                                    </Typography>
                                  </span> 
                                 <Typography variant="h6">03</Typography> 
                                </Box>
                              </Box>
                            </ListItem> */}
                          {/* <ListItem>
                              <Box className="tab-dtls">
                                <Box className="tab-dtls-hdr">
                            <span>
                                    <Image
                                      src={assest.tabIcon7}
                                      alt="icon7"
                                      width="10"
                                      height="12"
                                    />
                                    <Typography variant="h5">
                                      {" "}
                                      Due Date
                                    </Typography>
                                  </span> 
                               <Typography variant="h6">
                                    SEPT 31, 2022{" "}
                                    <Image
                                      src={assest.tabIcon8}
                                      alt="icon8"
                                      width="10"
                                      height="12"
                                    />{" "}
                                  </Typography>
                                </Box>
                              </Box>
                            </ListItem> */}
                        </List>
                      </Box>
                      <Box className="tab-panel-btm">
                        <Typography variant="h3">Details</Typography>
                        <Typography variant="body1">
                          DSP’s assist individuals with all of their personal needs and care plans including modeling socially appropriate behavior, help people participate in recreational programs that strengthen their life skills, and ensure a safe and comfortable environment. A primary purpose of the DSP is to assist people who need support to lead self-directed lives and to participate in their communities. We have openings for full and part-time Direct Support Professionals (DSP). Must have healthcare experience and worked with individuals with intellectual and/or developmental disabilities within a group home setting for a minimum of 1 year.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </SpecialSec>
      <WhatPeopleSay />
    </Wrapper>
  );
}
